/**
 * GridTwinX Frontend Entry Point
 *
 * Initializes the TerriaJS-based digital twin application.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryProvider } from './providers';
import App from './App';
import './index.css';

// Render the application
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryProvider>
      <App />
    </QueryProvider>
  </React.StrictMode>
);
